<script>
import { mapActions, mapState } from "vuex";
import professionalMixin from "@/mixins/professionals/professionalMixin";

export default {
  mixins: [professionalMixin],

  props: {
    professionalId: {
      type: String,
      required: true
    }
  },

  methods: {
    ...mapActions("professional", [
      "show",
      "startTraining",
      "approveTraining",
      "reproveOnTraining"
    ])
  },

  computed: {
    ...mapState("professional", ["professional", "loader"]),

    trainingStatus: function() {
      return this.professional.training_status;
    },

    canStartTraining: function() {
      return this.isPendingTraining(this.trainingStatus);
    },

    canApproveOnTraining: function() {
      return this.isInTraining(this.trainingStatus);
    },

    canReproveOnTraining: function() {
      return this.isInTraining(this.trainingStatus);
    }
  },

  async mounted() {
    await this.show(this.professionalId);
  }
};
</script>

<template>
  <div class="training">
    <div class="top">
      <span>Status do treinamento do profisisonal</span>

      <v-tooltip open-delay="0" close-delay="0" right>
        <template v-slot:activator="{ on }">
          <v-chip
            :color="trainingStatus | getStatus('color')"
            v-on="on"
            align-center
          >
            <span>{{ trainingStatus | getStatus("name") }}</span>
          </v-chip>
        </template>

        <span>{{ trainingStatus | getStatus("description") }}</span>
      </v-tooltip>
    </div>

    <div class="bottom" v-if="!isTrainingApproved(trainingStatus)">
      <v-btn
        v-if="canStartTraining"
        :loading="loader"
        small
        @click="startTraining()"
        color="primary"
      >
        Iniciar treinamento
      </v-btn>

      <v-btn
        v-if="canApproveOnTraining"
        :loading="loader"
        small
        @click="approveTraining()"
        color="primary"
      >
        Aprovar treinamento
      </v-btn>

      <v-btn
        v-if="canReproveOnTraining"
        :loading="loader"
        small
        @click="reproveOnTraining()"
        color="error"
      >
        Reprovar treinamento
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
.training {
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: solid 1px #e2e2e2;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}

.bottom > *:not(:last-child) {
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Register/Steps/Training.vue